export default "__VITE_ASSET__By$9FI8Y__"